<template>
  <div class="container pt-4 mb-4 ImpressaoPecasHabilitacao">
    <div id="botoes_edicao"
         :class="{
           'bt-scroll-top':resize.value < 200,
           'bt-scroll-float':resize.value > 200
         }">
      <div v-b-tooltip.hover.left="'Imprimir'"
           class="mt-2">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  @click="printPreview">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;"
                    icon="print" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Aumentar zoom'"
           class="mt-1">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  :disabled="zoom > 1"
                  @click="zoom++">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;color:white;"
                    icon="zoomPlus" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Menos zoom'"
           class="mt-1">
        <b-button class="Termo--btn-info"
                  style="padding: 6px 5.5px;"
                  :disabled="zoom < 1"
                  @click="zoom--">
          <icon-svg class="icon--xxs icons--white"
                    style="height: 1.3rem;width: 1.3rem;"
                    icon="zoomMinus" />
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Voltar ação'"
           class="mt-1">
        <b-button class="ImpressaoPecasHabilitacao--btn-no-select"
                  @click="exec($event,'undo')">
          <
        </b-button>
      </div>

      <div v-b-tooltip.hover.left="'Próxima ação'"
           class="mt-1">
        <b-button class="ImpressaoPecasHabilitacao--btn-no-select"
                  @click="exec($event,'redo')">
          >
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Negrito'"
           class="mt-1">
        <b-button class="ImpressaoPecasHabilitacao--btn-no-select"
                  :class="{'ImpressaoPecasHabilitacao--btn-selected':state.bold}"
                  @click="exec($event,'bold')">
          <b>B</b>
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Itálico'"
           class="mt-1">
        <b-button class="ImpressaoPecasHabilitacao--btn-no-select"
                  :class="{'ImpressaoPecasHabilitacao--btn-selected':state.italic}"
                  @click="exec($event,'italic')">
          <i>It</i>
        </b-button>
      </div>

      <div v-if="edit"
           v-b-tooltip.hover.left="'Sublinhado'"
           class="mt-1">
        <b-button class="ImpressaoPecasHabilitacao--btn-no-select"
                  :class="{'ImpressaoPecasHabilitacao--btn-selected':state.underline}"
                  @click="exec($event,'underline')">
          <u>U</u>
        </b-button>
      </div>
    </div>

    <!--<div class="row justify-content-end">
          <div class="col-3">
            <select class="form-control form-control-sm">
              <option>Memorial</option>
              <option>Declaração de Hipossuficiência</option>
              <option>Certidão de Habilitação</option>
            </select>
          </div>
        </div>-->

    <div class="row">
      <div class="col ImpressaoPecasHabilitacao--fundoBlack pt-2 pb-2">
        <div class="ImpressaoPecasHabilitacao--pagina"
             :class="{'ImpressaoPecasHabilitacao-zoom-2': zoom == 2, 'ImpressaoPecasHabilitacao-zoom-1': zoom == 1}"
             @click="getState"
             @keyup="getState">
          <div class="paste-html" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* others */
  import { mapGetters } from "vuex"

  /* services */
  import HabilitacaoService from "@/services/Registros/Habilitacao"

  export default {
    name: "ImpressaoFormularioHabilitacao",
    props: {
      propImpressao: { type: Object, default: () => ({})},
      propData: { type: Object, default: () => ({})},
      propOrdemServico: { type: Object, default: null}
    },
    computed: {
      ...mapGetters({
        resize: 'window/getScroll',
      }),
    },
    beforeMount () {
      const html = HabilitacaoService.getTemplateCertidao({
        habilitacao: this.propData,
        impressao: this.propImpressao,
        ordemServicoSelected: this.propOrdemServico
      })
      html.then(res => {
        document.querySelector('.paste-html').innerHTML = res.replace(/display: none;/g, 'display: block;')
      })
    },
    data () {
      return {
        zoom: 1,
        html: null,
        filePreview: null,
        state: {
          undo: false,
          redo: false,
          bold: false,
          italic: false,
          underline: false
        },
        edit: false
      }
    },
    methods: {
      exec ( event, command, value = null ) {
        document.execCommand(command, false, value)

        this.state = {
          undo: this.statusExec('undo'),
          redo: this.statusExec('redo'),
          bold: this.statusExec('bold'),
          italic: this.statusExec('italic'),
          underline: this.statusExec('underline'),
        }
      },

      statusExec (command) {
        let status = document.queryCommandState(command)
        return status
      },

      getState (event) {
        if (event.target.contentEditable == "true" ||
          event.target.parentElement.contentEditable == "true" ||
          event.target.parentElement.parentElement.contentEditable == "true" ||
          event.target.parentElement.parentElement.parentElement.contentEditable == "true") {
          this.edit = true
        } else {
          this.edit = false
        }

        this.state = {
          undo: this.statusExec('undo'),
          redo: this.statusExec('redo'),
          bold: this.statusExec('bold'),
          italic: this.statusExec('italic'),
          underline: this.statusExec('underline'),
        }
      },

      async printPreview () {
        this.$emit('onVisualizar')
      }
    }
  }
</script>

<style lang="scss">

    @import "./src/scss/_utilities/variables";

    .ImpressaoPecasHabilitacao {
        &--fundoBlack {
            background-color: black;
            height: 100%;
        }

        &--pagina {
            height: 100% !important;
            width: 210mm !important;
            margin: 10px auto !important;
        }
        &--btn-no-select{
            background-color: $color-gray;
            border-color: gray;
            color: white;
        }

        &--btn-selected{
            background-color: $sinoreg-blue;
            border-color: $sinoreg-blue;
            color: white;
        }

        &-zoom-2{
          transform: scale(1.15);
          margin-top: 6em !important;
          margin-bottom: 6em !important;
        }

        &-zoom-1{
          transform: scale(1.1);
          margin-top: 4em !important;
          margin-bottom: 4em !important;
        }
    }

    .pagina-marginBack {
      background-color: white !important;
      background-repeat: no-repeat;
      background-size: cover;
      height: 296mm !important;
    }
</style>
